import { defineMessages } from "react-intl";

const messages = defineMessages({
    contact: {
        id: "contact.title",
    },
    p: {
        id: "contact.p",
    },
    email: {
        id: "account.email",
    },
    message: {
        id: "contact.message",
    },
    send: {
        id: "general.send",
    },
    success: {
        id: "contact.success",
    },
    successMessage: {
        id: "contact.successMessage",
    },
    close: {
        id: "general.close",
    },
});

export default messages;
